enum GridFilterIds {
  ALL = '#all',
  VULNERABLE_DEVICES = '#vulnerableDevices',
  CRITICAL_UPDATES = '#criticalUpdates',
  AVAILABLE_UPDATES = '#availableUpdates',
  INSTALLED_UPDATES = '#installedUpdates'
}

export default GridFilterIds;
